export default __webpack_public_path__ + "static/media/SDG-icon-NL-01.5d675f16.svg";